import { createSlice } from '@reduxjs/toolkit';
import { getLoans, editLoan, updateLoan, fetchLoans, createLoan, deleteLoan, Hash } from './loanAPI';

const loanSlice = createSlice({
    name: 'loans',
    initialState: {
        loans: {
            gloans: [],
            floans: []
        },
        status: 'idle',
        error: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getLoans.fulfilled, (state, action) => {
                state.loans.gloans = action.payload;
                state.status = 'succeeded';
            })
            .addCase(getLoans.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getLoans.rejected, (state, action) => {
                state.error = action.error.message;
                state.status = 'failed';
            })
            .addCase(fetchLoans.fulfilled, (state, action) => {
                state.loans.floans = action.payload;
                state.status = 'succeeded';
            })
            .addCase(fetchLoans.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchLoans.rejected, (state, action) => {
                state.error = action.error.message;
                state.status = 'failed';
            })
            .addCase(createLoan.fulfilled, (state, action) => {
                state.loans.gloans.push(action.payload);
                state.loans.floans.push(action.payload);
                state.status = 'succeeded';
            })
            .addCase(createLoan.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createLoan.rejected, (state, action) => {
                state.error = action.error.message;
                state.status = 'failed';
            })
            .addCase(editLoan.fulfilled, (state, action) => {
                state.loans.gloans = state.loans.gloans.map(edit => {
                    if (edit._id === action.payload._id) return action.payload;
                    else return edit;
                });
                state.loans.floans = state.loans.floans.map(edit => {
                    if (edit._id === action.payload._id) return action.payload;
                    else return edit;
                });
                state.status = 'succeeded';
            })
            .addCase(editLoan.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(editLoan.rejected, (state, action) => {
                state.error = action.error.message;
                state.status = 'failed';
            })
            .addCase(updateLoan.fulfilled, (state, action) => {
                state.loans.gloans = state.loans.gloans.map(edit => {
                    if (edit._id === action.payload._id) return action.payload;
                    else return edit;
                });
                state.loans.floans = state.loans.floans.map(edit => {
                    if (edit._id === action.payload._id) return action.payload;
                    else return edit;
                });
                state.status = 'succeeded';
            })
            .addCase(updateLoan.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateLoan.rejected, (state, action) => {
                state.error = action.error.message;
                state.status = 'failed';
            })
            .addCase(deleteLoan.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(deleteLoan.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteLoan.rejected, (state, action) => {
                state.error = action.error.message;
                state.status = 'failed';
            })
            .addCase(Hash.fulfilled, (state) => {
                state.status = 'succeeded';
            })
            .addCase(Hash.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(Hash.rejected, (state, action) => {
                state.error = action.error.message;
                state.status = 'failed';
            });
    },
});

export default loanSlice.reducer;
